import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus, Minus } from "@phosphor-icons/react";
import { Reveal, Eyebrow } from "./Reveal";

const QA = [
  {
    q: "Do I have to change my number?",
    a: "No. Your number stays on the trucks. Your phone just passes along the calls you don't pick up.",
  },
  {
    q: "Is this a robot answering my phone?",
    a: "No. It's a text, same as if you texted them back yourself, except it goes out in sixty seconds instead of at nine at night.",
  },
  {
    q: "My wife answers the phone.",
    a: "Then this only fires when she's off the desk or on the other line. If she never misses one, you don't need me.",
  },
  {
    q: "We already have an answering service.",
    a: "Those are good after hours. This catches the middle of the day, when everyone is on a roof.",
  },
  {
    q: "Who am I dealing with?",
    a: "Carlo Vescio, in Niagara Falls. I set it up, I run it, and you have my cell. Not a 1-800 number in Toronto.",
  },
  {
    q: "Does every caller get the text?",
    a: "Nearly. A caller on a landline or with their number hidden can't receive a text, so those still go to voicemail like they do now.",
  },
];

export const Faq = () => {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="border-t-2 border-line" data-testid="faq-section">
      <div className="mx-auto max-w-6xl px-4 py-20 sm:px-6 sm:py-28">
        <Reveal>
          <Eyebrow>Heard it before?</Eyebrow>
          <h2 className="mt-4 font-display text-3xl font-bold uppercase leading-none tracking-tight sm:text-4xl md:text-5xl">
            Fair questions
          </h2>
        </Reveal>
        <div className="mt-12">
          {QA.map((item, i) => {
            const isOpen = open === i;
            return (
              <Reveal key={item.q} delay={i * 0.04}>
                <div className="border-b-2 border-line">
                  <button
                    type="button"
                    data-testid={`faq-question-${i + 1}`}
                    aria-expanded={isOpen}
                    aria-controls={`faq-answer-${i + 1}`}
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    className="flex min-h-[64px] w-full items-center justify-between gap-6 py-5 text-left"
                  >
                    <span className="font-display text-xl font-bold uppercase tracking-tight sm:text-2xl">
                      {item.q}
                    </span>
                    {isOpen ? (
                      <Minus weight="bold" className="h-7 w-7 shrink-0 text-safety" aria-hidden="true" />
                    ) : (
                      <Plus weight="bold" className="h-7 w-7 shrink-0 text-safety" aria-hidden="true" />
                    )}
                  </button>
                  <AnimatePresence initial={false}>
                    {isOpen && (
                      <motion.div
                        id={`faq-answer-${i + 1}`}
                        data-testid={`faq-answer-${i + 1}`}
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                        className="overflow-hidden"
                      >
                        <p className="max-w-3xl pb-6 text-base leading-relaxed text-gray-300 sm:text-lg">
                          {item.a}
                        </p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
